// Справка (/help): разделы приходят из core (GET /api/help) и правятся в админке «Справка»;
// здесь отрисовка, якоря заголовков и поиск.
// Значок «?» на экранах (components/HelpHint.vue) ведёт на /help/<раздел>#<заголовок>.
import { Marked } from 'marked'

// the sections from core (GET /api/help); an error goes to the caller: the page says the help
// is unavailable instead of showing other texts
export async function loadHelpSections(apiClient) {
  const { data } = await apiClient.get('/help')
  return (data.items || []).map(s => ({ id: s.slug, title: s.title, text: s.body }))
}

export function findSection(id, sections) {
  return sections.find(s => s.id === id) || sections[0] || null
}

// the anchors of the headings of a text ("## Заголовок {#id}")
export function anchorsOf(text) {
  return [...(text || '').matchAll(/^#{1,6}\s.*\{#([a-z0-9-]+)\}\s*$/gm)].map(m => m[1])
}

// The id of a heading: "## Язык запросов {#qlang}" gives id="qlang"; without the suffix — none.
const ANCHOR = /\s*\{#([a-z0-9-]+)\}\s*$/

const escapeHtml = (v) => v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

const marked = new Marked({
  renderer: {
    heading({ tokens, depth }) {
      const raw = this.parser.parseInline(tokens)
      const m = raw.match(ANCHOR)
      const text = m ? raw.replace(ANCHOR, '') : raw
      return m ? `<h${depth} id="${m[1]}">${text}</h${depth}>\n` : `<h${depth}>${text}</h${depth}>\n`
    }
  }
})

// HTML of a section; the words of the search are marked in the text (not inside tags)
export function renderHelp(text, words = []) {
  let html = marked.parse(text)
  if (!words.length) return html
  const pattern = new RegExp(`(${words.map(w => escapeHtml(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi')
  return html.split(/(<[^>]+>)/).map(part => (part.startsWith('<') ? part : part.replace(pattern, '<mark>$1</mark>'))).join('')
}
